import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tab-label" }
const _hoisted_2 = ["title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Badge = _resolveComponent("Badge")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock(_component_el_tabs, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
    class: "tabs",
    "tab-position": $props.tabPosition
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" need to update keys when content is changed(for count) "),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.c_tabs, (tab) => {
        return (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: JSON.stringify(tab),
          class: "tab",
          label: tab.title,
          name: tab.value
        }, {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", {
                title: tab.title
              }, _toDisplayString(tab.title), 9 /* TEXT, PROPS */, _hoisted_2),
              (tab.icon)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: tab.icon,
                    stroke: "#4D4C4B",
                    "stroke-width": "1",
                    size: "1.4rem"
                  }, null, 8 /* PROPS */, ["icon"]))
                : _createCommentVNode("v-if", true),
              (typeof tab.count === 'number')
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 1,
                    class: "badge",
                    gray: _ctx.value !== tab.value,
                    brand: _ctx.value === tab.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.count), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["gray", "brand"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "name"]))
      }), 128 /* KEYED_FRAGMENT */)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "tab-position"]))
}